module.exports = __webpack_public_path__ + "static/media/TH3.c6cfa7d4.jpg";